import React, { createContext, useContext, useState } from 'react';
import { useMobile } from '../hooks/useMobile';

const ViewModeContext = createContext();

export const useViewMode = () => {
  const context = useContext(ViewModeContext);
  if (!context) {
    throw new Error('useViewMode must be used within ViewModeProvider');
  }
  return context;
};

export const ViewModeProvider = ({ children }) => {
  const isMobileDevice = useMobile();
  const [forceDesktop, setForceDesktop] = useState(() => {
    return localStorage.getItem('forceDesktop') === 'true';
  });
  const [forceMobile, setForceMobile] = useState(() => {
    return localStorage.getItem('forceMobile') === 'true';
  });

  const switchToDesktop = () => {
    localStorage.setItem('forceDesktop', 'true');
    localStorage.removeItem('forceMobile');
    setForceDesktop(true);
    setForceMobile(false);
  };

  const switchToMobile = () => {
    localStorage.setItem('forceMobile', 'true');
    localStorage.removeItem('forceDesktop');
    setForceMobile(true);
    setForceDesktop(false);
  };

  const resetToAuto = () => {
    localStorage.removeItem('forceDesktop');
    localStorage.removeItem('forceMobile');
    setForceDesktop(false);
    setForceMobile(false);
  };

  const shouldShowMobile = forceMobile || (isMobileDevice && !forceDesktop);

  return (
    <ViewModeContext.Provider value={{ isMobileDevice, shouldShowMobile, forceDesktop, forceMobile, switchToDesktop, switchToMobile, resetToAuto }}>
      {children}
    </ViewModeContext.Provider>
  );
};
